import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    height: '100%',
    textAlign: 'center',
    '& > h2': {
      fontSize: defaultTheme.font.size.l,
      color: defaultTheme.color.secondary,
      fontWeight: 'bold',
      marginBottom: defaultTheme.spacing.xxl,
    },
    '& > h3': {
      fontSize: defaultTheme.font.size.m,
      color: defaultTheme.color.secondary,
      fontWeight: 'bold',
      marginTop: defaultTheme.spacing.xxl,
      marginBottom: defaultTheme.spacing.m,
      height: ['auto', 'auto', '18px', '18px'],
    },
    '& > p': {
      fontSize: defaultTheme.font.size.s,
      color: defaultTheme.color.secondary,
      marginBottom: defaultTheme.spacing.l,
      height: ['auto', 'auto', '16px', '16px'],
    },
    '& > img': {
      width: ['295px', '295px', '240px', '240px'],
    },
    '& > div > Button': {
      marginTop: defaultTheme.spacing.xxl,
      width: ['100%', '100%', '320px', '320px'],
      height: '56px',
    },
  }),
);
